import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import CommentUrl from './commentUrl';
import ShareIconBox from './shareIconBox';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ShareBox extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        interact: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { docData, interact } = this.props;
        const { columnData } = docData;
        const { url } = columnData;

        return (
            <div>
                <ul className={styles.share_comment}>
                    <CommentUrl docData={docData} />
                    <li>
                        <span>|</span>
                    </li>
                    {!interact?.isCloseShare && (
                        <>
                            <ShareIconBox docData={docData} />
                            <li>
                                <span>|</span>
                            </li>
                        </>
                    )}
                    <li>
                        <a href={url} target="_blank">
                            返回栏目
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}

export default errorBoundary(ShareBox);
